var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    viewBox: "0 0 48 48",
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.496094 12 L 19 12 L 19 35 L 6.496094 35 Z M 6.496094 12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.320312 20.234375 L 24.523438 20.234375 L 24.523438 27.132812 L 34.191406 27.132812 C 33.289062 31.519531 29.519531 34.035156 24.523438 34.035156 C 18.621094 34.035156 13.871094 29.328125 13.871094 23.480469 C 13.871094 17.632812 18.621094 12.925781 24.523438 12.925781 C 27.0625 12.925781 29.355469 13.816406 31.160156 15.28125 L 36.402344 10.082031 C 33.207031 7.320312 29.109375 5.617188 24.523438 5.617188 C 14.523438 5.617188 6.496094 13.574219 6.496094 23.480469 C 6.496094 33.386719 14.523438 41.34375 24.523438 41.34375 C 33.535156 41.34375 41.730469 34.847656 41.730469 23.480469 C 41.730469 22.425781 41.566406 21.289062 41.320312 20.234375 Z M 41.320312 20.234375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.496094 5.480469 L 41.730469 5.480469 L 41.730469 24 L 6.496094 24 Z M 6.496094 5.480469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.320312 20.234375 L 24.523438 20.234375 L 24.523438 27.132812 L 34.191406 27.132812 C 33.289062 31.519531 29.519531 34.035156 24.523438 34.035156 C 18.621094 34.035156 13.871094 29.328125 13.871094 23.480469 C 13.871094 17.632812 18.621094 12.925781 24.523438 12.925781 C 27.0625 12.925781 29.355469 13.816406 31.160156 15.28125 L 36.402344 10.082031 C 33.207031 7.320312 29.109375 5.617188 24.523438 5.617188 C 14.523438 5.617188 6.496094 13.574219 6.496094 23.480469 C 6.496094 33.386719 14.523438 41.34375 24.523438 41.34375 C 33.535156 41.34375 41.730469 34.847656 41.730469 23.480469 C 41.730469 22.425781 41.566406 21.289062 41.320312 20.234375 Z M 41.320312 20.234375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.496094 5.480469 L 41.730469 5.480469 L 41.730469 41.34375 L 6.496094 41.34375 Z M 6.496094 5.480469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.320312 20.234375 L 24.523438 20.234375 L 24.523438 27.132812 L 34.191406 27.132812 C 33.289062 31.519531 29.519531 34.035156 24.523438 34.035156 C 18.621094 34.035156 13.871094 29.328125 13.871094 23.480469 C 13.871094 17.632812 18.621094 12.925781 24.523438 12.925781 C 27.0625 12.925781 29.355469 13.816406 31.160156 15.28125 L 36.402344 10.082031 C 33.207031 7.320312 29.109375 5.617188 24.523438 5.617188 C 14.523438 5.617188 6.496094 13.574219 6.496094 23.480469 C 6.496094 33.386719 14.523438 41.34375 24.523438 41.34375 C 33.535156 41.34375 41.730469 34.847656 41.730469 23.480469 C 41.730469 22.425781 41.566406 21.289062 41.320312 20.234375 Z M 41.320312 20.234375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 12 L 41.730469 12 L 41.730469 41.34375 L 15 41.34375 Z M 15 12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.320312 20.234375 L 24.523438 20.234375 L 24.523438 27.132812 L 34.191406 27.132812 C 33.289062 31.519531 29.519531 34.035156 24.523438 34.035156 C 18.621094 34.035156 13.871094 29.328125 13.871094 23.480469 C 13.871094 17.632812 18.621094 12.925781 24.523438 12.925781 C 27.0625 12.925781 29.355469 13.816406 31.160156 15.28125 L 36.402344 10.082031 C 33.207031 7.320312 29.109375 5.617188 24.523438 5.617188 C 14.523438 5.617188 6.496094 13.574219 6.496094 23.480469 C 6.496094 33.386719 14.523438 41.34375 24.523438 41.34375 C 33.535156 41.34375 41.730469 34.847656 41.730469 23.480469 C 41.730469 22.425781 41.566406 21.289062 41.320312 20.234375 Z M 41.320312 20.234375"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M 4.855469 34.035156 L 4.855469 12.925781 L 18.785156 23.480469 Z M 4.855469 34.035156"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M 4.855469 12.925781 L 18.785156 23.480469 L 24.523438 18.527344 L 44.1875 15.359375 L 44.1875 3.992188 L 4.855469 3.992188 Z M 4.855469 12.925781"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M 4.855469 34.035156 L 29.4375 15.359375 L 35.910156 16.171875 L 44.1875 3.992188 L 44.1875 42.96875 L 4.855469 42.96875 Z M 4.855469 34.035156"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M 44.1875 42.96875 L 18.785156 23.480469 L 15.507812 21.042969 L 44.1875 12.925781 Z M 44.1875 42.96875"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogl);
export default __webpack_public_path__ + "static/media/googl.83bb6621a0278a0b5d800e797c6242ce.svg";
export { ForwardRef as ReactComponent };